// @ts-nocheck
import React from 'react';

const ShipMethodDeleteAlert = React.lazy(
  () => import('@/containers/Alerts/ShipMethods/ShipMethodDeleteAlert'),
);

export default [{ name: 'ship-method-delete', component: ShipMethodDeleteAlert }];
